import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type AddDetachSEHModalProps = {
  itemId: string;
};

function makeDetachSEHControl() {
  const tags = ["Yes"];
  return [
    makeSelectControl(
      "Detach?",
      "detach",
      tags,
      "Please confirm that you are detaching SEH.",
    ),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function AddDetachSEHModal({ itemId }: AddDetachSEHModalProps) {
  const tagFormControl = React.useMemo(() => makeDetachSEHControl(), []);
  const addTagToast = useCustomToast(() => (
    <Alert status="success">SEH detached!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_DETACH_SEH,
    addTagToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = "Detaching SEH";
      (data.comments ? (data.comments as string) + ", " : "") + "detaching SEH";
      addStep(comments);
    },
    [addStep],
  );

  return (
    <ButtonModal label="Detach SEH" title="Detach SEH" size="sm">
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
